<template>
  <div class="availables__deptos-box">
    <div class="availables__deptos-title">
      <div :class="changeColorCount" class="count">{{ availables }}</div>
      <div class="text">
        <h2>DEPARTAMENTOS DISPONIBLE</h2>
      </div>
    </div>

    <div class="box__availables__deptos-buttons">
      <div class="availables__deptos-buttons">
        <!-- <div @click="showAllModels()" :class="fillAll" class="availables__casas-buttons-btn"></div> -->
        <div class="availables__casas-buttons-text">
          <font-awesome-icon
            :class="fillAll"
            @click="showAllModels()"
            :icon="iconCircle"
            class="availables__deptos-buttons-btn"
          />TODOS
        </div>
      </div>
    </div>
    <div class="contents-rangers prices-depas">
      <h2 class="center-text range__container-title">
        Filtrar Niveles de Departamentos
      </h2>
      <div class="range__container-item range-price-container">
        <div class="range-numbers range-numbers-left">Número de nivel</div>
        <div class="range-buttons range-buttons-price">
          <vue-slider
            class="rangeprice-custom range-price-custom range-depas-levels"
            v-model="value_2"
            :min="minVal"
            :max="returnLvls"
            :adsorb="true"
            :interval="1"
            :marks="true"
            @change="updateActiveModel(returnNames)"
          >
          </vue-slider>
        </div>
      </div>
    </div>
    <div class="contents-rangers" v-if="priceFilterRange">
      <h2 class="center-text range__container-title">
        Filtrar Precios de Departamentos
      </h2>
      <div class="range__container-item range-price-container">
        <div class="range-numbers range-numbers-left">
          {{ formatValue(returnMinPrice) }}
        </div>
        <div class="range-buttons range-buttons-price">
          <vue-slider
            class="rangeprice-custom range-price-custom"
            :tooltip-formatter="(val) => formatValue(val)"
            v-model="rangePrice"
            :min="returnMinPrice"
            :max="returnMaxPrice"
            :enable-cross="false"
            @change="updateActiveModelPrices()"
          >
          </vue-slider>
        </div>
        <div class="range-numbers range-numbers-right">
          {{ formatValue(returnMaxPrice) }}
        </div>
      </div>
    </div>

    <!-- <div class="box__availables__deptos-buttons">
      <div
        class="availables__deptos-buttons"
        v-for="(model, index) in setModels"
        :key="index"
      >
        
        <div class="availables__deptos-buttons-text">
          <font-awesome-icon
            :class="fillActive(model)"
            @click="updateActiveModel(model)"
            :icon="iconCircle"
            class="availables__deptos-buttons-btn"
          />{{ model.name }}
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
export default {
  components: {
    VueSlider,
  },
  props: [
    "existFilter",
    "activeModel",
    "priceFilterRange",
    "priceFilterRangeDtos",
    "desarrollo",
  ],
  data() {
    return {
      fillAll: "active__btn-deptos",
      mutateModel: "",
      iconCircle: faCircle,
      value_2: null,
      rangePrice: "",
      name: "",
      arrPrices: "",
      minVal:0,
    };
  },
  computed: {
    ...mapGetters({
      filterModelos: "getStatusFilterModelos",
    }),
    setModels() {
      let personasMap = this.existFilter.map((item) => {
        return [item.name, item];
      });
      var personasMapArr = new Map(personasMap);
      return [...personasMapArr.values()];
    },
    availables() {
      if(this.desarrollo =="torrespaseodelparque" || this.desarrollo =="torrevistahermosa"){
        let arr = this.filterModelos.filter((i) =>  i.available > 0);
        let arrF=[]
        for (let index = 0; index < arr.length; index++) {
          arrF[index]=arr[index].available
        }
        const reducer = (accumulator, curr) => accumulator + curr;
        let sum = arrF.reduce(reducer)
        return sum
      }else{
        let arr = this.filterModelos.filter((i) =>  i.available > 0)
        return arr.length
      }
    },
    changeColorCount() {
      if (this.available >= 0) {
        return "count__unavailable";
      } else {
        return "count__available";
      }
    },
    returnLvls() {
      let personasMap = this.existFilter.map((item) => {
        return [item.name, item];
      });
      var personasMapArr = new Map(personasMap);
      
      if(this.desarrollo=='torreaireaplus' || this.desarrollo=='canadas_deptos'|| this.desarrollo=='torrespanorama'){
        return [...personasMapArr.values()].length;
      }else{
        return [...personasMapArr.values()].length - 1;
      }
    },
    returnNames() {
      if (this.value_2 == 0) {
        return "PLANTA BAJA";
      } else {
       if(this.desarrollo=='torrespanorama' && this.$route.params.id==62){
         if(this.value_2==6){
           return `PENTHOUSE PLANTA BAJA`
         }else if(this.value_2==7){
           return `PENTHOUSE PLANTA ALTA`
         }else{
           return `${this.name} ${this.value_2}`;
         }
       }else{
         if(this.desarrollo=='torrespanorama' && this.$route.params.id==61){
           if(this.value_2==6){
           return `${this.name} ${this.value_2} `
          }else{
            return `${this.name} ${this.value_2}`
          }
         }
          return `${this.name} ${this.value_2}`;
       }
      }
    },
    returnMinPrice() {
      if (this.priceFilterRange) {
        return Number(this.priceFilterRange[0]);
      } else {
        return 0;
      }
    },
    returnMaxPrice() {
      if (this.priceFilterRange) {
        return Number(this.priceFilterRange[1]);
      } else {
        return 0;
      }
    },
    returnPrices() {
      if (this.priceFilterRangeDtos) {
        return this.priceFilterRangeDtos;
      } else {
        return "";
      }
    },
    returnListPrices() {
      var list = [];
      for (var clave in this.arrPrices) {
        var elem = this.arrPrices[clave].filter((i) => i >= this.rangePrice[0] && i <= this.rangePrice[1]);
        if (elem.length > 0) {
          list.push(clave);
        }
      }
      return list;
    },
  },
  methods: {
    ...mapActions(["getFilterModelos"]),
    formatValue(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    updateActiveModel(model) {
      let typeModel;
      let arrModel;
      typeModel = model;
      arrModel = this.existFilter.filter((i) => {
          return i.name === typeModel
      });
      this.$emit("onUpdateModel", arrModel);

      this.mutateModel = model.name;
      this.fillAll = "";
      this.defaultRange()
    },
    updateActiveModelPrices() {
      /* let typeModel; */
      let arrModel;
      /* typeModel = model; */
      let list = this.returnListPrices
      let filtered =[]
      let unav = this.existFilter.filter((i) =>  i.available==0)
      let finalArray=[]
      list.forEach((arr) => {
          arrModel = this.existFilter.filter((i) => {
            return i.name === arr && i.available>0
        });
        filtered = filtered.concat(arrModel);
        finalArray = unav.concat(filtered)
         this.mutateModel = "";
         this.value_2=0
      })
      if(finalArray.length==0){
        this.$emit("onUpdateModel", unav);
       
      }else{
        this.$emit("onUpdateModel", finalArray);
      }
      
      this.fillAll = "active__btn-deptos";
     /*  this.mutateModel = model.name; */
     
    },
    showAllModels() {
      this.getFilterModelos(this.existFilter);
      this.fillAll = "active__btn-deptos";
      this.mutateModel = "";
      this.value_2 = null;
      this.defaultRange()
     
    },
    fillActive(model) {
      if (this.mutateModel === model.name) {
        return "active__btn-deptos";
      } else {
        return "desactive__btn-casas";
      }
    },
    defaultRange(){
         this.rangePrice = [this.returnMinPrice, this.returnMaxPrice];
    },
    detectedDevelop(){
      if (this.desarrollo == "torrespaseodelparque") {
      this.name = "PISO";
      this.minVal=0
      this.value_2=0
      
    }else if(this.desarrollo=='torreaireaplus' || this.desarrollo=='canadas_deptos'  || this.desarrollo == "torrevistahermosa"){
      this.name = "NIVEL";
      this.minVal=-2
      this.value_2=-2
    }else if(this.desarrollo=='torrespanorama'){
      this.name="PISO"
      this.minVal=1
      this.value_2=1
     }
    }
  },
  mounted() {
    this.defaultRange()
    this.arrPrices = this.returnPrices;
    /* console.log(this.priceFilterRange) */
    this.detectedDevelop()

  },
  created() {},
  updated() {},
};
</script>
<style>
.rangeprice-custom.range-depas-levels .vue-slider-process{
  background: transparent;
}
</style>
<style scoped>
.range__container-item {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding-top: 2rem;
}
.range-numbers {
  font-size: 1.4rem;
  /* min-width: 40px; */

  /* width: 25%; */
  font-weight: 700;
}

.range-buttons {
  width: 100%;
  max-width: 300px;
}
.rangeprice-custom .vue-slider-dot-handle {
  background: #152541;
}
.rangeprice-custom .vue-slider-process {
  background: #152541;
}
.rangeprice-custom .vue-slider-dot-tooltip-inner {
  background: #152541;
  border-color: #152541;
}
.range-numbers-left {
  text-align: right;
  padding-right: 15px;
}
.range-numbers-right {
  text-align: left;
  padding-left: 15px;
}
.prices-depas{
    padding-bottom: 5rem;
    padding-top: 2rem;
}
@media (min-width: 1201px) {
  .range__container-title {
    font-size: 1.8rem;
  }
}

@media (max-width: 1200px) {
  .range__container-title {
    font-size: 2.3rem;
  }
}
.availables__casas-box {
  padding-bottom: 3rem;
}

@media (max-width: 767.67px) {
  .range__container-title {
    font-size: 2rem;
  }
}
</style>